import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { API, THEME, DISABLE_OI, DISABLE_CBM, SESSION_TIMEOUT, DISABLE_THREEDS_MICROSERVICE,DISABLE_DOMAIN_MONITOR} from "../config/config";
import OtpVerify from "../components/OtpVerify";
import OptionVerify from "../components/OptionVerify";
import Multilingual from "./../helper/Multilingual";
import md5 from "md5";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import AssociationsChecker from "./../helper/AssociationsChecker";
import { Form, Input, Button, Row, Col, ConfigProvider, Typography } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";

import CBMToken from "../helper/CBMToken";
import ThreeDSToken from "../helper/ThreeDSToken";
import FetchUserGroups from "../helper/FetchUserGroups";
import FetchUserAccess from "../helper/FetchUserAccess";
import FetchUserAssociations from "../helper/FetchUserAssociations";
import TxFindToken from "../helper/TxFindToken";
import DomainMonitorToken from "../helper/DomainMonitorToken";
import MenuAccess from "../helper/MenuAccess";
import GroupAccess from "../helper/GroupAccess";
import { takeRedirectLocation } from "../helper/SessionTimeout";

const { Paragraph } = Typography;

const Login = (props) => {
    const [t, locale, getDropdownSelectLanguage] = Multilingual();
    const [login, setLogin] = useState({ email: "", password: "" });
    const [user, setUser] = useState(null);
    const [otp, setOtp] = useState("");
    const [rememberme, setRemember] = useState("");
    const [isLoginLoading, setIsLogingLoading] = useState(false);
    const [isSessionExpired, setIsSessionExpired] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false); // to prevent multiple verify requests

    const layout = {
        layout: "vertical",
    };

    const timeoutAfter = SESSION_TIMEOUT && Number.isInteger(SESSION_TIMEOUT) && SESSION_TIMEOUT > 1 ? SESSION_TIMEOUT : 15;

    useEffect(() => {
       
        const favicon = document.getElementById("favicon");
        favicon.href = `../themes/${THEME ? THEME : "default"}/favicon.ico`;

        document.title = t("login.login");
        if (localStorage.getItem("loggedUser")) {
            const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));


            if (loggedUser && Cookies.get("access_token")) {
                const redirectLocation = takeRedirectLocation(loggedUser.username);
                props.history.push(redirectLocation || (GroupAccess("VIEW REPORT ONLY") ? "/alert_resolution_report" : "/dashboard"));
            } else {
                localStorage.clear();
            }
        }
        if (localStorage.getItem("sessionExpired")) {
            setIsSessionExpired(true);
            localStorage.removeItem("sessionExpired");
        }

        preCookieCheck();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const formValChange = (chgV, allV) => {
        setLogin(allV);
    };

    const optionChange = (payload) => {
        setUser({ ...user, ...payload });
    };

    const otpChange = (otp) => {
        setOtp(otp);
    };

    const rememberChange = (rme) => {
        setRemember(rme.target.checked);
    };

    const onFinish = (values) => {
        setIsLogingLoading(true);
        setIsSessionExpired(false);
        axios
            .post(API + "/login", { "username": values.username, "password": values.password, "last_user_remember_me": Cookies.get("last_user_remember_me") },{withCredentials: true})
            .then(async ({ data }) => {
                if (!data) {
                    setIsLogingLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: t("login.dialogs.login_error"),
                        showConfirmButton: false,
                        timer: 2000,
                    });
                } else {
                    if(data.status === 'EXC'){
                        if(data.error_msg.custom_msg === 'md5_encryption_method'){
                            Swal.fire({
                                icon: "warning",
                                title: data.error_msg.msg,
                                showConfirmButton: true,
                                onClose: () => {
                                    updatePassword(values);
                                },
                            });
                        }else{
                            setIsLogingLoading(false);
                            Swal.fire({
                                icon: "error",
                                title: data.error_msg.msg ? data.error_msg.msg : data.error_msg,
                                showConfirmButton: true,
                            });
                        }
                    }else{
                        setIsLogingLoading(false);
                        setUser(data);
                        if (data.skip_2fa || data.rememberme) {
                            onVerify(data);
                        }
                    }
                }
            })
            .catch((error) => {
                if(error.response.data.error_msg.custom_msg === 'md5_encryption_method'){
                    Swal.fire({
                        icon: "warning",
                        title: error.response.data.error_msg.msg,
                        showConfirmButton: true,
                        onClose: () => {
                            updatePassword(values);
                        },
                    });
                }else{
                    setIsLogingLoading(false);
                    Swal.fire({
                        icon: "error",
                        title: error.response.data.error_msg.msg ? error.response.data.error_msg.msg : error.response.data.error_msg,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                }
            });
    };

    const updatePassword = (values) => {
        axios
            .post(API + "/updatepassword", { "username": values.username },{withCredentials: true})
            .then(async ({ data }) => {
                if (!data) {
                    Swal.fire({
                        icon: "error",
                        title: t("login.dialogs.login_error"),
                        showConfirmButton: false,
                        timer: 2000,
                    });
                } else  {
                    if(data.status === 'EXC'){
                        Swal.fire({
                            icon: "error",
                            title: data.error_msg,
                            showConfirmButton: false,
                            timer: 2000,
                        });
                    }else{
                        window.open("/resetpassword/"+data.token,'_self');
                    }
                }
            })
            .catch((error) => {
                Swal.fire({
                    icon: "error",
                    title: error.response.data.error_msg,
                    showConfirmButton: false,
                    timer: 2000,
                });
            });
    }

    const preCookieCheck = () => {
        axios
            .post(API + "/sendcookiechecker", {},{withCredentials: true})
            .then(async () => {
                setIsLogingLoading(false);
            });
    };

    const storeUserDataInCookies = (userdata) => {
        // Cookies can only be so large, so only keep what's necessary there. user id, menu items, remember me, any tokens.
        const authuser = window.btoa(`${userdata.userid}:${userdata.username}`);

        Cookies.set("authuser", authuser, { secure: true, sameSite: "Strict"});
        Cookies.set("access", JSON.stringify(userdata.access), { secure: true, sameSite: "Strict"});
        Cookies.set("groups", JSON.stringify(userdata.groups), { secure: true, sameSite: "Strict"});
        Cookies.set("access_token", userdata.access_token, { secure: true, sameSite: "Strict"});
        Cookies.set("associations", JSON.stringify(userdata.associations), { secure: true, sameSite: "Strict"});
        Cookies.set("menu_items", JSON.stringify(userdata.menu_items), { secure: true, sameSite: "Strict" });

        Cookies.set("userid", userdata.userid, { secure: true, sameSite: "Strict" });
        Cookies.set("remember_me", userdata.rememberme, { secure: true, sameSite: "Strict" });
        Cookies.set("verify_option", userdata.verify_option, { secure: true, sameSite: "Strict" });
    };

    const onVerify = async (userbypass = null) => {

        if (isVerifying) {
            return false;
        }
        setIsVerifying(true);

        let userdata = null;

        if (user) {
            userdata = user;
        } else if (userbypass) {
            userdata = userbypass;
        } else {
            setIsVerifying(false);
            return false;
        }

        // const rememberme = userbypass?.rememberme ? !userbypass.rememberme : true;
        if (!userdata?.skip_2fa && !userdata?.rememberme) {
            const postdata = {
                otp:otp
            };
            if (rememberme) {
                postdata.rememberme = 'on'
            }

            const dataotpverify = await axios //
                .post(API + "/otpverify", postdata, { withCredentials: true, headers: { Authorization: "Bearer " + userdata.access_token } })
                .then(({ data }) => data)
                .catch(() => false);

            if (!dataotpverify?.verify) {
                setOtp("");
                setIsVerifying(false);
                Swal.fire({
                    icon: "error",
                    title: t("login.dialogs.verify_error"),
                    showConfirmButton: false,
                    timer: 2000,
                });

                return false;
            }
            // store lastuserrememberme in cookies
            if (rememberme && dataotpverify?.rememberme_value){
                Cookies.set("last_user_remember_me", dataotpverify.rememberme_value, { secure: true, sameSite: "Strict" });
            }
            
        }
      
        let userAccess, userAssociations, userGroups;
        try {
            [userAccess, userAssociations, userGroups] = await Promise.all([
                FetchUserAccess(userdata.access_token, userdata.userid),
                FetchUserAssociations(userdata.access_token, userdata.userid),
                FetchUserGroups(userdata.access_token, userdata.userid)
            ]);
        } catch (err) {
            setIsLogingLoading(false);
            setIsVerifying(false);
            Swal.fire({
                icon: "error",
                title: t("login.dialogs.catch"),
                showConfirmButton: false,
                timer: 2000,
            });
            return false;
        }
        userdata = {
            ...userdata,
            ...userAccess,
            ...userAssociations,
            ...userGroups
        }


        userdata = { ...userdata, fullName: `${userdata.firstname} ${userdata.lastname}` };
        userdata = { ...userdata, expiry: moment().add(timeoutAfter, "minutes").format() };

        await storeUserDataInCookies(userdata);
        
        // theme and theme settings (preferred page size etc) in local storage.
        let loggedUser = {
            username: userdata.username,
            email: userdata.email,
            fullname: userdata.fullName,
            firstname: userdata.firstname,
            lastname: userdata.lastname,
            theme: userdata.theme,
            theme_compact: userdata.theme_compact,
            theme_logo: userdata.theme_logo,
            expiry: userdata.expiry,
            password_changed: userdata.password_changed,
        }

        loggedUser = { ...loggedUser, validate: md5(JSON.stringify(loggedUser)) };

        localStorage.setItem("loggedUserSettings", userdata.dashboard_settings ? JSON.stringify(userdata.dashboard_settings) : '{}');
        localStorage.setItem("loggedUser", JSON.stringify(loggedUser));
        if (userdata.theme) {
            if (Array.isArray(userdata.theme)) {
                // Removed by Jericho 2023-08-23 - Removing the txshield themes/reseller logo
                // Logo from Reseller
                // if (userdata.theme[0].logo) {
                //     localStorage.setItem("logo", userdata.theme[0].logo);
                // }

                if (userdata.theme[0].dashboardtheme) {
                    localStorage.setItem("dashboardtheme", userdata.theme[0].dashboardtheme.replaceAll('/"', "'"));
                }
            }
        }

        // Removed by Jericho 2023-08-23 - Removing the txshield themes/reseller logo
        // TxShield Themes Logo, this will override the reseller logo
        // if (userdata?.theme_logo) {
        //     localStorage.setItem("logo", userdata.theme_logo);
        // }

        // OI Access
       
        if(!DISABLE_OI){
            // always check txfind token 
            const data = await TxFindToken(Cookies.get("userid"));
            if (data.token){
                Cookies.set("txfind_token", data.token, { secure: true, sameSite: "Strict"});
                Cookies.set("oiAssociation", data.associatedMerchantIds, { secure: true, sameSite: "Strict"});
                Cookies.set("oiEnrollments", data.enrollments, { secure: true, sameSite: "Strict"});

            } else {
                Cookies.remove("txfind_token");
                Cookies.remove("oiAssociation");
                Cookies.remove("oiEnrollments");
            }
        }

        // CBM Access
        if (!DISABLE_CBM) {
            if(AssociationsChecker("CBM")){
                const token = await CBMToken(Cookies.get("userid"));
                if(token)
                {
                    Cookies.set("cbm_token", token, { secure: true, sameSite: "Strict"});
                }else{
                    Cookies.remove("cbm_token");
                }
            } else {
                Cookies.remove("cbm_token");
            }
        }

        // THREEDS ACCESS
        if(!DISABLE_THREEDS_MICROSERVICE){

            /**
             * Check if the logging user is associated with threeds, 
             * if not remove any existing threeds token in cookies just in case,
             * if yes then get a new token and store in cookies
             * 
             * Key notes: the route usergroups already returns if the user has access to threeds its either the
             * access is from user to merchant association or user to microservice merchant association.
             * 
             */
            if(!MenuAccess('threeDS')) {
                Cookies.remove("threeds_token");
            } else {
                const token = await ThreeDSToken(Cookies.get("userid"));

                if(token)
                {
                    let associations = JSON.parse(Cookies.get("associations"));
                    associations.push({
                        'type': 'THREEDS',
                        'access': ['view'],
                        'refs': null,
                        'name':'THREEDS'
                    })
                    Cookies.set("associations", JSON.stringify(associations), { secure: true, sameSite: "Strict"});
                    Cookies.set("threeds_token", token, { secure: true, sameSite: "Strict"});
                } else {
                    Cookies.remove("threeds_token");
                }
            }
        }

         // Domain monitor Access
        
        if(!DISABLE_DOMAIN_MONITOR){
            // Single call returns { token, dm_userids, isSysadmin }. Scope enforced server-side
            // via the group_tokens row referenced by the JWT — no need to echo user ids back.
            Cookies.remove("dm_userid");
            const tokenData = await DomainMonitorToken(Cookies.get("userid"));
            if (tokenData && tokenData.token) {
                Cookies.set("dm_token", tokenData.token, { secure: true, sameSite: "Strict" });
                Cookies.set("dm_userids", JSON.stringify(tokenData.dm_userids || []), { secure: true, sameSite: "Strict" });
            } else {
                Cookies.remove("dm_token");
                Cookies.remove("dm_userids");
            }
        }
        setIsLogingLoading(false);

        // Page the user was on when the session ended (same tab, same user, in-app paths only)
        const redirectLocation = takeRedirectLocation(userdata.username);
        const defaultRoute = GroupAccess("VIEW REPORT ONLY") ? "/alert_resolution_report" : "/dashboard";
        props.history.push(redirectLocation ? redirectLocation : defaultRoute)

        // Swal.fire({
        //     icon: "success",
        //     title: t("login.dialogs.login_success"),
        //     showConfirmButton: false,
        //     timer: 2000,
        //     onClose: () => {
        //         let redirectLocation = localStorage.getItem("redirectLocation");
        //         localStorage.setItem("redirectLocation","");
        //         props.history.push(redirectLocation ? redirectLocation : "/dashboard")
        //     },
        // });
    };

    const getSelectLanguage = () => {
        return (
            <Row type="flex" gutter={[8, 0]} justify="end" style={{ marginBottom: "1rem" }}>
                <Col>{getDropdownSelectLanguage()}</Col>
            </Row>
        );
    };

    const renderForm = () => {
        return <ConfigProvider locale={locale}>
            <div className={`login-warp ${locale.locale}`}>
                <div className="login-warp--box">
                    <img
                        src={`../themes/${THEME ? THEME : "default"}/payshield-origin.png`}
                        width={"100%"}
                        style={{ display: "block", maxWidth: "300px", margin: "0 auto 1rem auto" }}
                        alt="payshield dashboard"
                    />
                    {getSelectLanguage()}
                    {isSessionExpired ? (
                        <Paragraph type="danger" className="text-center">
                            {t("login.session.expired")}
                        </Paragraph>
                    ) : (
                        ""
                    )}
                    <Form {...layout} onValuesChange={formValChange} onFinish={() => onFinish(login)}>
                        <Form.Item name="username" rules={[{ required: true, message: t("login.required.username") }]}>
                            <Input
                                size="large"
                                placeholder={t("login.username")}
                                prefix={<UserOutlined style={{ color: "gray" }} />}
                                disabled={isLoginLoading}
                            />
                        </Form.Item>
                        <Form.Item name="password" rules={[{ required: true, message: t("login.required.password") }]} style={{ marginBottom: ".5rem" }}>
                            <Input.Password
                                size="large"
                                placeholder={t("login.password")}
                                prefix={<LockOutlined style={{ color: "gray" }} />}
                                disabled={isLoginLoading}
                            />
                        </Form.Item>
                        <Form.Item className="text-right" style={{ marginBottom: ".5rem" }}>
                            <Link to={"/forgotpassword"}>{t("login.forgotpassword")}</Link>
                        </Form.Item>
                        <Form.Item className="text-center">
                            <Button type="primary" htmlType="submit" className="login-form-button" size="large" shape="round" loading={isLoginLoading}>
                                {t("login.login")}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </ConfigProvider>
    }

    return !user ? 
        renderForm()
     : !user['skip_2fa'] && !user['rememberme'] ? (
        !user["verify_option"] ? (
            <ConfigProvider locale={locale}>
                <OptionVerify t={t} email={user.email} access_token={user.access_token} handleChange={optionChange} />
            </ConfigProvider>
        ) : !user['rememberme'] ? (
            <ConfigProvider locale={locale}>
                <OtpVerify
                    t={t}
                    otp={otp}
                    rememberme={ rememberme }
                    handleChange={otpChange}
                    handleCheckboxChange={rememberChange}
                    onSubmit={onVerify}
                    option={user["verify_option"]}
                    qrcode={user["2fa_qrcode"]}
                    secret={user["2fa_secret"]}
                    firstlogin_succeed={user["first_time_verify"]}
                />
            </ConfigProvider>
        ): renderForm()
    ) : renderForm();
};

export default Login;
